import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { SEO } from "@/components/SEO";
import { MapPin } from "lucide-react";

const ServicedAreas = () => {
  const cities = [
    "Edmonton", "Calgary", "Red Deer", "Lethbridge", 
    "St. Albert", "Medicine Hat", "Grande Prairie", "Airdrie", 
    "Spruce Grove", "Leduc", "Cochrane", "Fort McMurray",
    "Lloydminster", "Camrose", "Beaumont", "Sherwood Park",
    "Okotoks", "Chestermere", "Brooks", "Wetaskiwin",
    "Fort Saskatchewan", "Winterburn", "Goodridge Corners", "Alberta Park", 
    "Rampart Industrial", "Ellerslie Industrial", "Acheson", "Nisku"
  ];

  return (
    <Layout>
      <SEO
        title="Serviced Areas | Automation & AI for Small Businesses in Edmonton"
        description="Missed Call Rescue serves Edmonton and surrounding Alberta areas with top-tier automation and AI solutions for small businesses."
        canonical="/serviced-areas"
      />
      <div className="pt-24 pb-16 md:pt-32 md:pb-24 bg-slate-50 min-h-screen">
        <div className="container mx-auto px-4">
          <div 
            className="max-w-3xl mx-auto text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6">AI Solutions Serviced Areas for Alberta Small Businesses</h1>
            <p className="text-lg text-slate-700 leading-relaxed mb-4">
              Missed Call Rescue your #1 source for <strong className="text-primary font-bold">Ai Solutions</strong> for small business based in Edmonton, Alberta. We offer solutions across Canada but have a special promotion for the Alberta Cities listed below.
            </p>
            <p className="text-lg text-slate-700 font-medium leading-relaxed mb-6">
              If you operate a small business from any one of the local areas below be sure to add in your location for a introductory offer for all new customers! Please put your local city in the email subject line.
            </p>
            <p className="text-xl font-semibold text-primary">
              Local Alberta Location Promotion:
            </p>
          </div>

          <div 
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-4xl mx-auto"
          >
            {cities.map((city, index) => {
              const slug = city.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
              const to = city === "Edmonton" ? "/edmonton-business" : `/serviced-areas/${slug}`;
              return (
                <Link
                  key={index}
                  to={to}
                  className="bg-primary/5 p-4 rounded-xl shadow-sm border border-primary/20 flex items-center space-x-3 hover:shadow-md transition-shadow hover:border-primary/40 cursor-pointer group"
                >
                  <MapPin className="h-5 w-5 text-primary flex-shrink-0" />
                  <span className="font-semibold text-primary group-hover:underline">{city}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ServicedAreas;
